import { useState, useEffect } from 'react';
import { FormControl, Select, MenuItem } from '@mui/material';

function DeviceSelector({ onSelect, devices, preferredDevice, label }) {
  const [selectedDevice, setSelectedDevice] = useState('');

  useEffect(() => {
    if (preferredDevice) {
      const preferred = devices.find(
        (device) => device.deviceId === preferredDevice
      );
      if (preferred) {
        setSelectedDevice(preferred.deviceId);
      } else {
        setSelectedDevice(devices[0]?.deviceId);
      }
    } else {
      setSelectedDevice(devices[0]?.deviceId);
    }
  }, [preferredDevice, devices]);

  useEffect(() => {
    if (selectedDevice) {
      onSelect(selectedDevice);
    }
  }, [selectedDevice, onSelect]);

  function handleChange(event) {
    setSelectedDevice(event.target.value);
  }

  // Helper function to extract the display name
  function getDisplayName(label) {
    // Assuming the format is "Device Name (string) (vId:pId)", we remove the last parentheses
    return label.replace(/\s*\([^()]*\)\s*$/, '');
  }

  return (
    <FormControl fullWidth>
      <Select
        value={selectedDevice}
        onChange={handleChange}
        displayEmpty
        title={label}
        inputProps={{
          'aria-label': label,
          title: label,
        }}
        sx={{
          '& .MuiSelect-select': {
            padding: '8.5px 14px',
            fontSize: '14px',
          },
        }}
      >
        {devices.map((device) => (
          <MenuItem key={device.deviceId} value={device.deviceId}>
            {getDisplayName(device.label)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default DeviceSelector;
